import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitOrganizationSizeLogic } from './hooks/useNonprofitOrganizationSizeLogic';
import { NonprofitOrganizationSizeForm } from './NonprofitOrganizationSizeForm';

export const EddNonprofitOrganizationSize = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitOrganizationSizeLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.nonprofitOrganizationSize.title')}
        headingContainerCustomStyle='!mb-[24px]'>
        <NonprofitOrganizationSizeForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
